import NewsSummaryCard from "./NewsSummaryCard";

export default NewsSummaryCard;
